// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"18":"fa15ebe8","66":"e93c893e","166":"b04fd5c1","313":"16c998b5","350":"a88660c4","565":"0ad210d3","639":"12750909","751":"5d38ba4a","761":"a603c3a6","854":"5846fb6f","922":"5464e2dd"}[chunkId] + ".js";
};